(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digor-hero"] && !Shopify.designMode) return;
  try {
    
  function configureDigorCampaignVideos(root = document) {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    root.querySelectorAll('[data-digor-campaign-video]').forEach((video) => {
      if (video.dataset.motionPreferenceBound === 'true') return;
      video.dataset.motionPreferenceBound = 'true';
      let pageReady = document.readyState === 'complete';
      let visible = false;
      const syncMotionPreference = () => {
        if (motionQuery.matches || !pageReady || !visible || !video.isConnected) {
          video.pause();
          video.removeAttribute('autoplay');
          return;
        }

        if (!video.getAttribute('src')) {
          video.src = window.matchMedia('(max-width: 749px)').matches
            ? video.dataset.mobileSrc
            : video.dataset.desktopSrc;
        }
        video.setAttribute('autoplay', '');
        video.muted = true;
        video.play().catch(() => {});
      };

      const revealVideo = () => video.classList.add('is-ready');

      if (video.readyState >= 2) {
        revealVideo();
      } else {
        video.addEventListener('loadeddata', revealVideo, { once: true });
      }

      motionQuery.addEventListener('change', syncMotionPreference);
      const observer = new IntersectionObserver((entries) => {
        visible = entries.some((entry) => entry.isIntersecting);
        syncMotionPreference();
      });
      observer.observe(video);
      const afterLoad = () => window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          pageReady = true;
          syncMotionPreference();
        });
      });
      if (pageReady) {
        pageReady = false;
        afterLoad();
      } else {
        window.addEventListener('load', afterLoad, { once: true });
      }
      const cleanup = (event) => {
        if (!event.target.contains(video)) return;
        observer.disconnect();
        motionQuery.removeEventListener('change', syncMotionPreference);
        window.removeEventListener('load', afterLoad);
        document.removeEventListener('shopify:section:unload', cleanup);
        video.pause();
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }

  configureDigorCampaignVideos();
  document.addEventListener('shopify:section:load', (event) => {
    configureDigorCampaignVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digor-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDuoBuilders = (scope = document) => {
      scope.querySelectorAll('[data-duo-builder]').forEach((builder) => {
        if (builder.dataset.duoInitialized === 'true') return;

        const dialog = builder.parentElement.querySelector('[data-duo-dialog]');
        const openButton = builder.querySelector('[data-duo-open]');
        if (!dialog || !openButton) return;

        const form = dialog.querySelector('[data-duo-form]');
        const closeButton = dialog.querySelector('[data-duo-close]');
        const selects = [...dialog.querySelectorAll('[data-duo-select]')];
        const submitButton = dialog.querySelector('[data-duo-submit]');
        const submitLabel = dialog.querySelector('[data-duo-submit-label]');
        const errorMessage = dialog.querySelector('[data-duo-error]');
        const defaultSubmitLabel = submitLabel.textContent;

        const hideError = () => {
          errorMessage.hidden = true;
          errorMessage.textContent = '';
        };

        const showError = (message) => {
          errorMessage.textContent = message;
          errorMessage.hidden = false;
          errorMessage.focus();
        };

        const updatePreview = (select) => {
          const choice = select.closest('.digor-duo-choice');
          const preview = choice.querySelector('[data-duo-preview]');
          const image = choice.querySelector('[data-duo-image]');
          const title = choice.querySelector('[data-duo-title]');
          const price = choice.querySelector('[data-duo-price]');
          const option = select.options[select.selectedIndex];

          if (!option || !option.value) {
            preview.hidden = true;
            image.hidden = true;
            image.removeAttribute('src');
            image.alt = '';
            title.textContent = '';
            price.textContent = '';
            return;
          }

          title.textContent = option.dataset.title || option.textContent;
          price.textContent = option.dataset.price || '';
          if (option.dataset.image) {
            image.src = option.dataset.image;
            image.alt = option.dataset.title || '';
            image.hidden = false;
          } else {
            image.hidden = true;
            image.removeAttribute('src');
            image.alt = '';
          }
          preview.hidden = false;
        };

        openButton.addEventListener('click', () => {
          hideError();
          dialog.showModal();
        });

        closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => openButton.focus());

        selects.forEach((select) => {
          select.addEventListener('change', () => {
            hideError();
            updatePreview(select);
          });
          updatePreview(select);
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          hideError();

          const selectedOptions = selects.map((select) => select.options[select.selectedIndex]);
          const productIds = selectedOptions.map((option) => option.dataset.productId);
          if (productIds[0] === productIds[1]) {
            showError(form.dataset.sameError);
            selects[1].focus();
            return;
          }

          submitButton.disabled = true;
          submitLabel.textContent = form.dataset.addingLabel;

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: selects.map((select) => ({
                  id: Number(select.value),
                  quantity: 1
                }))
              })
            });

            if (!response.ok) throw new Error('cart-add-failed');
            window.location.assign(`${root}cart`);
          } catch (error) {
            showError(form.dataset.addError);
            submitButton.disabled = false;
            submitLabel.textContent = defaultSubmitLabel;
          }
        });

        builder.dataset.duoInitialized = 'true';
      });
    };

    initializeDuoBuilders();
    document.addEventListener('shopify:section:load', (event) => initializeDuoBuilders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--cart"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const minus = event.target.closest('[data-wetheme-section-type="template--cart"] .js-qty__adjust--minus');
    if (!minus) return;
    const input = minus.closest('.js-qty').querySelector('.js-qty__num');
    if (Number(input.value) !== 1) return;
    const remove = minus.closest('.cart__row').querySelector('a.cart__remove');
    if (!remove) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(remove.href);
  }, true);

  } catch(e) { console.error(e); }
})();
})();
